import SideBarLayout from 'common/layouts/SideBarLayout/SideBarLayout';
import SideBarAudio from 'modules/glifos-rich-media/components/SideBarAudio/SideBarAudio';
import SideBarVideo from 'modules/glifos-rich-media/components/SideBarVideo/SideBarVideo';
import Alert from 'modules/website/components/Alert/Alert';
import ContentCard from 'modules/website/components/ContentCard/ContentCard';
import OrderBy from 'modules/website/components/Research/OrderBy/OrderBy';
import { useCategoryId, useCategoryTreePage } from 'modules/website/hooks/useCategoryTreePage';
import React, { useEffect, useState } from 'react'
import { Col, Placeholder, Row } from 'react-bootstrap';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import styles from './CategoryView.module.scss';
import ApiURLs from 'services/BackendApi/BackendApiURLs';
import SideBarDocument from 'modules/glifos-rich-media/components/SideBarDocument/SideBarDocument';
import BasicLayout from 'common/layouts/BasicLayout/BasicLayout';
import SearchSquareForm from 'modules/glifos-rich-media/components/SearchSquareForm/SearchSquareForm';
import BrowseSquare from 'modules/website/components/BrowseSquare/BrowseSquare';
import OptionCard from 'modules/website/components/Category/OptionCard/OptionCard';
import Pagination from 'modules/website/components/Pagination/Pagination';
import LoadingBody from 'modules/website/components/loadingBody/loadingBody';
import Header from 'modules/website/components/Article/Header/Header';
import GeneralLeftBar from 'modules/website/components/GeneralLeftBar/GeneralLeftBar';
import CitationCard from 'modules/website/components/CitationCard/CitationCard';
import ShareButton from 'modules/website/components/New/ShareButton/ShareButton';
import { Download } from 'react-bootstrap-icons';
import { PulseLoader } from 'react-spinners';
import EmailSender from 'modules/glifos-rich-media/components/EmailSender/EmailSender';

const secondStyleAlias = [
  {
    title: 'Genocide Memorials',
    alias: 'category/Memorials',
    noSideBar: true
  },
  {
    title: 'Unity and Reconciliation',
    alias: 'category/Unity_and_Reconciliation',
    noSideBar: true
  },
  {
    title: 'Unity and Reconciliation',
    alias: 'category/Unity_and_Reconciliation',
    noSideBar: true
  },
  {
    title: 'National Youth Council',
    alias: 'category/National_Youth_Council',
    noSideBar: false
  },
  {
    title: 'AERG',
    alias: 'category/AERG_programmes',
    noSideBar: false
  },
  {
    title: 'Peace and Love Proclaimers',
    alias: 'category/Peace_and_Love_Proclaimers',
    noSideBar: false
  },
  {
    title: 'Idebate',
    alias: 'category/Idebate',
    noSideBar: false
  },
  {
    title: 'Aegis Youth Department',
    alias: 'category/Aegis_Youth_Department',
    noSideBar: false
  },
  {
    title: 'GAERG',
    alias: 'category/GAERG',
    noSideBar: false
  },
  {
    title: 'Walk to Remember',
    alias: 'category/Walk_to_Remember',
    noSideBar: false
  }
]
export default function CategoryView(props) {
  const { useWhiteLogo } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const alias = location.pathname.replace('/', '');
  //console.log(alias)
  //const { category } = useParams();
  //const tid = 8212;
  const [breadC, setBreadC] = useState(null);
  const [sideBar, setSideBar] = useState(null);
  const [order, setOrder] = useState('glifosid')
  const [page, setPage] = useState(1);

  const { isLoading: isLoadingId, isError: isErrorId, payload: payloadId, error: errorId } = useCategoryId({
    //category: 'category-' + tid,
    alias: alias,
  });
  const { isLoading, isError, payload, error } = useCategoryTreePage({
    category: 'category-' + payloadId?.tid,
    page: 1,
    tid: payloadId?.tid,
    sortby: order,
    orderby: 'asc',
    page: page,
  });

  const url = new URL(window.location.href);
  const pageUrl = url.searchParams.get('page');

  useEffect(() => {
    setPage(pageUrl);
  }, [pageUrl]);

  useEffect(() => {
    if (isErrorId) {
      navigate('/404')
    }
    if (isError) {
      navigate('/404')
    }
  }, [isErrorId, isError])

  const downloadFiles = async (fileId) => {
    console.log(fileId);
  
    // Transformar el array para obtener solo los documentos
    const transformedArray = fileId.map(item =>
      item.thumbnail.replace('/api/v1/file/get/', '').replace('?w=480', '').replace('?w=480', '')
    );
  
    const info = {
      title: payload.title,
      documents: transformedArray
    };
  
    //console.log(info);
  
    try {
      setLoading(true); // Activar estado de carga
  
      const response = await fetch(`${ApiURLs.baseURL}/v1/file/downloadarticles`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
        },
        body: JSON.stringify(info),
      });
  
      if (!response.ok) {
        throw new Error("Error al descargar el archivo");
      }
  
      let filename = response.headers.get("X-Filename");
      filename = filename ? decodeURIComponent(filename) : `Issue-${payload.title}.zip`;
  
      const blob = await response.blob();
  
      if (blob.size === 0) {
        throw new Error("El archivo ZIP está vacío o no se generó correctamente");
      }
  
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
    } finally {
      setLoading(false); // Desactivar estado de carga
    }
  };

  /* const downloadFiles = async (fileId) => {
    console.log(fileId);

    // Transformar el array para obtener solo los documentos
    const transformedArray = fileId.map(item => (item.thumbnail.replace('/api/v1/file/get/', '').replace('?w=480', '').replace('?w=480', '')
    ));

    const info = {
      title: payload.title,
      documents: transformedArray
    };

    console.log(info);

    try {
      setLoading(true); // Activar estado de carga

      const response = await fetch(`${ApiURLs.baseURL}/v1/file/downloadarticles`, {
        method: "POST", // Cambiamos a POST
        headers: {
          "Content-Type": "application/json",*/
          //Accept: "*/*",
        /*},
        body: JSON.stringify(info), // Enviamos la información en el cuerpo de la solicitud
      });

      if (!response.ok) {
        throw new Error("Error al descargar el archivo");
      }

      let filename = response.headers.get("X-Filename");
      filename = filename ? decodeURIComponent(filename) : `archivo_${fileId}.bin`;

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
    } finally {
      setLoading(false); // Desactivar estado de carga
    }
  }; */

  /* const downloadFiles = async (fileId) => {
    console.log(fileId)
    //Get in the array the files to download item.thumbnail
    const transformedArray = fileId.map(item => ({
      document: item.thumbnail.replace('/api/v1/file/get/', '').replace('?w=480', '').replace('?w=480', ''),
    }));
    const info = {
      title: payload.title,
      documents: transformedArray
    }

    console.log(info)
    //info to string
    const infoString = JSON.stringify(info);
    try {
      setLoading(true); // Activar estado de carga

      const response = await fetch(`${ApiURLs.baseURL}/v1/file/downloadarticles/${infoString}`, {
        method: "GET",
        headers: { */
  //Accept: "*/*",
  /* },
});

if (!response.ok) {
  throw new Error("Error al descargar el archivo");
}

let filename = response.headers.get("X-Filename");
filename = filename ? decodeURIComponent(filename) : `archivo_${fileId}.bin`;

const blob = await response.blob();
const url = window.URL.createObjectURL(blob);
const link = document.createElement("a");
link.href = url;
link.setAttribute("download", filename);
document.body.appendChild(link);
link.click();
link.remove();
window.URL.revokeObjectURL(url);
} catch (error) {
console.error("Error al descargar:", error);
} finally {
setLoading(false); // Desactivar estado de carga
}
}; */

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    let bread = [
      {
        title: 'Collections',
        path: '/collections',
      }
    ];
    if (payload) {
      payload.parent_category.map((item) => {
        bread.push({
          title: item.name,
          path: item.tid,
        });
      });
      bread.push({
        title: payload.title,
        path: '',
      });

    }
    setBreadC(bread);
  }, [payload])

  if (isLoading || isLoadingId) return (
    <SideBarLayout
      useWhiteLogo={useWhiteLogo}
      leftBar={<GeneralLeftBar />}>
      <div>
        <div className="d-flex justify-content-between p-0">
          <Placeholder xs={4} className="plHol" />
          <Placeholder xs={4} className="plHol" />
        </div>
        <Row className="bod">
          {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => {
            return (
              <Placeholder as="p" animation="wave">
                <Placeholder xs={7} size="sm" /> <Placeholder xs={4} size="sm" />
                <Placeholder xs={4} size="sm" /> <Placeholder xs={7} size="sm" />
                <Placeholder xs={8} size="sm" /> <Placeholder xs={3} size="sm" />
                <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={3} size="sm" /> <Placeholder xs={1} size="sm" />
              </Placeholder>
            );
          })}
        </Row>
      </div>
    </SideBarLayout>
  )

  //console.log(isErrorId)
  //console.log(isError)

  if (!isLoading && !isError && payload && breadC && !isLoadingId && !isErrorId && payloadId) {
    return (
      <SideBarLayout
        title={payload.title}
        breadC={breadC}
        description={payload.description}
        leftBar={<GeneralLeftBar />}
        broCategory={payload?.parent_category[payload?.parent_category.length - 1]?.id}
        useWhiteLogo={useWhiteLogo}
      >
        {isLoading && <LoadingBody />}
        {!isLoading && isError && <Alert variant='danger'>{error}</Alert>}
        {!isLoading && !isError && payload && (
          <div>
            <div
              style={{ display: 'flex', justifyContent: 'flex-end', gap: '15px' }}
            >
              {
                Array.isArray(
                  payload?.solr_content?.records?.record
                ) ? (
                  payload?.solr_content?.records?.record?.length > 0 && (
                    payload?.solr_content?.records?.record[0].contenttype === 'glifos_digital_archive' && (
                      loading ? (
                        <div className={`${styles.btnloading}`}>
                          <PulseLoader
                            loading={true}
                            size={5}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      ) : (
                        <div className={`${styles.btn}`} onClick={() => downloadFiles(payload?.solr_content?.records?.record)}>
                          <Download className={`${styles.icon}`} />
                          Download individual articles
                        </div>
                      )
                    )
                  )
                ) : (
                  payload?.solr_content?.records?.record?.contenttype === 'glifos_digital_archive' && (
                    loading ? (
                      <div className={`${styles.btnloading}`}>
                        <PulseLoader
                          loading={true}
                          size={5}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    ) : (
                      <div className={`${styles.btn}`} onClick={() => downloadFiles(payload?.solr_content?.records?.record)}>
                        <Download className={`${styles.icon}`} />
                        Download individual articles
                      </div>
                    )
                  )
                )
              }
              <ShareButton title={payload?.title} />
              <EmailSender secondstyle={true} />
            </div>
            <div className={`${styles.categories}`}>
              {
                payload?.parent_category && payload?.parent_category.length > 0 && (
                  <>
                    <Link to='/Categories'>Categories: </Link>
                    <div className={`${styles.category}`}>
                      <Link to={payload?.parent_category[0].tid}>{payload?.parent_category[0].name}</Link>
                    </div>
                  </>
                )
              }
            </div>
            {/* <Header title={payload.title} /> */}
            <div className={`${styles.title}`}>{payload?.title}</div>
            <div className={`${styles.description}`}>
              <div dangerouslySetInnerHTML={{ __html: payload?.description }} />
            </div>
            <div className='d-flex justify-content-between p-0 mb-5'>
              {/* <OrderBy
                order={order}
                setOrder={setOrder}
              /> */}
              {payload?.solr_content?.result_header?.total_results !== "NaN" &&
                payload?.solr_content?.result_header?.total_results > 0 && (
                  <div className="d-flex flex-column justify-content-center ms-2 ">
                    {payload?.solr_content?.result_header?.total_results !== "NaN"
                      ? payload?.solr_content?.result_header?.total_results
                      : "0"}{" "}
                    results
                  </div>
                )}
              <Pagination result_header={payload?.solr_content?.result_header} justify='end' />
            </div>
            <Row className={`${styles.rowCards}`}>

              {/* {payload?.solr_content?.records?.record?.map((option, index) => (
                  <Col lg={4} md={12} key={index}>
                    <ContentCard title={option.title} link={option.id} description={option.blurb} image={option.image} />
                  </Col>
                ))} */}
              {payload?.solr_content?.records?.record ?
                (Array.isArray(
                  payload?.solr_content?.records?.record
                ) ? (
                  payload?.solr_content?.records?.record.length > 0 ? (
                    payload?.solr_content?.records?.record?.map(
                      (item, index) => {
                        return (
                          secondStyleAlias.find(item => item.alias === alias) ? (
                            <Col
                              key={index}
                              md={12}
                              lg={12}
                              xl={12}
                              className='mb-4'
                            >
                              {/* <ContentCard
                            key={index}
                            title={item.title}
                            image={
                              ApiURLs.baseURL +
                              item.thumbnail
                            }
                            description={item.blurb}
                            nav={item.id}
                            searchable={item.searchable}
                          /> */}
                              <OptionCard
                                image={
                                  ApiURLs.baseURL +
                                  item.thumbnail
                                }
                                title={item.title}
                                link={item.id}
                                description={item.blurb} />
                            </Col>
                          ) : (

                            <Col
                              key={index}
                              md={12}
                              lg={12}
                              xl={12}
                            >
                              {
                                item.contenttype === 'glifos_digital_archive' ? <CitationCard data={item} /> : (
                                  <ContentCard
                                    key={index}
                                    title={item.title}
                                    image={
                                      ApiURLs.baseURL +
                                      item.thumbnail
                                    }
                                    description={item.blurb}
                                    nav={item.id}
                                    searchable={item.searchable}
                                  />
                                )
                              }
                            </Col>
                          ))
                      }
                    )
                  ) : (
                    <div className={`${styles.noFound}`}>
                      No results were found
                    </div>
                  )

                ) : (
                  <Col md={12} lg={12} className='mb-4'>
                    {
                      payload?.solr_content?.records?.record.contenttype === 'glifos_digital_archive' ? <CitationCard data={payload?.solr_content?.records?.record} /> : (

                        <ContentCard
                          title={
                            payload?.solr_content?.records
                              ?.record.title
                          }
                          image={
                            ApiURLs.baseURL +
                            payload?.solr_content?.records
                              ?.record.thumbnail
                          }
                          description={
                            payload?.solr_content?.records
                              ?.record.blurb
                          }
                          nav={
                            payload?.solr_content?.records
                              ?.record.id
                          }
                        />
                      )
                    }
                  </Col>
                ))
                :
                <div className={`${styles.noFound}`}>
                  No results were found
                </div>
              }
            </Row>
            <div className='mt-5 mb-5'>
              <Pagination result_header={payload?.solr_content?.result_header} justify='start' />
            </div>
          </div>

        )}
      </SideBarLayout>
    )
  }
}
